import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit'
import { routerMiddleware } from 'connected-react-router'
import { createBrowserHistory } from 'history'
import logger from 'redux-logger'
import rootReducer from '../reducers/rootReducer'
import { saveState } from './localStorage'
import _ from 'lodash'

export const history = createBrowserHistory()

const reducer = rootReducer(history)
const middleware = [
  ...getDefaultMiddleware({
    serializableCheck: false,
  }),
  routerMiddleware(history),
  logger,
]
const initialState = []

const store = configureStore({
  reducer,
  middleware,
  devTools: process.env.NODE_ENV !== 'production',
  initialState,
})

store.subscribe(
  _.throttle(() => {
    saveState({
      company: store.getState().company,
      router: store.getState().router,
      recon: store.getState().recon,
      approval: store.getState().approval,
      productMapping: store.getState().productMapping,
      reports: store.getState().reports,
      emailReports: store.getState().emailReports,
      backup365Reports: {
        selectedCompany: store.getState().backup365Reports.selectedCompany
        }
    })
  }, 1000)
)

export default store
